export default __webpack_public_path__ + "static/top-8510b8c66642ae3290b24955155227f1.jpg";